import { Checkbox, Radio, Select } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import useWeekDays from 'src/Hooks/CalendarLogic/useWeekDays';
import { TransformValues } from 'src/types/transform-values.type';
import getNestedValue from 'src/Utils/getNestedValue';

import styles from './EventCreationAdvancedMonthDaySelect.module.scss';
import { Props } from './EventCreationAdvancedMonthDaySelect.types';

const EventCreationAdvancedMonthDaySelect = <T, O extends TransformValues<T>>({
  form,
  pathMonthDayNumberOrAdvanced = 'recurrence.monthDayNumberOrAdvanced',
  pathAdvancedMonthDay = 'recurrence.byWeekDay',
  pathAdvancedMonthWeek = 'recurrence.byMonthDay',
  pathCustomFrequency = 'recurrence.customFrequency',
  pathMonthDaySelected = 'recurrence.monthDaySelected',
}: Props<T, O>) => {
  const { t } = useTranslation();

  const customFrequencyValue = getNestedValue(form.values, pathCustomFrequency);
  const monthDayNumberOrAdvancedValue = getNestedValue(form.values, pathMonthDayNumberOrAdvanced);
  const monthDaySelectedValue = getNestedValue(form.values, pathMonthDaySelected);

  const disabled =
    (customFrequencyValue === 'MONTHLY' && monthDayNumberOrAdvancedValue === 'number') ||
    (customFrequencyValue === 'YEARLY' && !monthDaySelectedValue);

  const weekDays = useWeekDays();
  return (
    <div className={styles.container}>
      {customFrequencyValue === 'MONTHLY' ? (
        <Radio value={'advanced'} />
      ) : (
        <Checkbox {...form.getInputProps(pathMonthDaySelected, { type: 'checkbox' })} />
      )}

      <div className={styles.label}>{t('createEventForm.the', 'Le')}</div>
      <Select
        disabled={disabled}
        data={[
          {
            value: '1',
            label: t('createEventForm.first', 'premier'),
          },
          {
            value: '2',
            label: t('createEventForm.second', 'deuxième'),
          },
          {
            value: '3',
            label: t('createEventForm.third', 'troisième'),
          },
          {
            value: '4',
            label: t('createEventForm.fourth', 'quatrième'),
          },
          {
            value: '5',
            label: t('createEventForm.fifth', 'cinquième'),
          },
          {
            value: '-2',
            label: t('createEventForm.secondToLast', 'avant-dernier'),
          },
          {
            value: '-1',
            label: t('createEventForm.last', 'dernier'),
          },
        ]}
        {...form.getInputProps(pathAdvancedMonthWeek)}
      />
      <Select
        disabled={disabled}
        data={[
          {
            value: '',
            label: t('createEventForm.day', 'jour du mois'),
          },
          ...weekDays.map(day => ({ value: day.rruleIndex.toString(), label: day.fullName })),
        ]}
        {...form.getInputProps(pathAdvancedMonthDay)}
      />
    </div>
  );
};

export default EventCreationAdvancedMonthDaySelect;
